const serviceChannel = resolve =>
  require(['../../../views/personalCenter/serviceChannel'], resolve)
// 服务通道
export default [
  {
    path: '/serviceChannel',
    component: serviceChannel
  }
]



// WEBPACK FOOTER //
// ./src/router/page/personalCenter/serviceChannel.js